import { Box, Container, ListItemIcon, MenuItem, Typography } from "@mui/material";
import MaterialReactTable from "material-react-table";
import React, { useEffect, useMemo, useState } from "react";
import Navbar from "../../Navbar";
import { getData } from "../../../services/library";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import PeopleIcon from '@mui/icons-material/People';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import { useNavigate } from "react-router-dom";
import ReceiptIcon from '@mui/icons-material/Receipt';
import NuevaFacturacion from "../../facturacion_especial/NuevaFacturacion";

function EntregaConRemito() {
  let navigate = useNavigate();
  const [clientes, setClientes] = useState([]);
  const [dataCliente, setDataCliente] = useState({})
  const [resumenFacturas, setResumenFacturas] = useState(false)
  const [clientesAsociados, setClientesAsociados] = useState(false)
  const [tabla, setTabla] = useState(true);
  const [showNuevaFactura, setShowNuevaFactura] = useState(false);
  const [clienteAFacturar, setClienteAFacturar] = useState(null);
  let sucursales=localStorage.getItem("suc_auth").split(",")
  const obtenerClientes = () => {
    getData("/envasado_clientes/entregaconremito/"+sucursales, setClientes);
  };

  useEffect(() => {
    obtenerClientes();
  }, []);

    const closeNuevaFacturacion = () => {
      setTabla(true);
      setShowNuevaFactura(false);
      // api.getPedidos();
    };

  const columns = useMemo(
    () => [
      {
        accessorKey: "id", 
        header: "ID",
        maxSize: 20,
      },
      {
        accessorKey: "razon_social",
        header: "Razón Social",
        size: 230,
      },
      {
        accessorKey: "direccion_fiscal",
        header: "Dirección Fiscal",
        size: 180,
      },
      {
        accessorKey: "nombre_sucursal", 
        header: "Sucursal",
        size: 180,
      },
    ],
    [],
  );

  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "success",
    size: "small",
  };

  const customLocalization = {
    ...MRT_Localization_ES,
    expandAll: "Ex", // Cambia 'Expandir todo' a 'Ex'
    expand: "Ex", // Cambia 'Expandir' a 'Ex'
  };

  const initialState = {
    density: "compact",
    pagination: { pageIndex: 0, pageSize: 50 },
    showGlobalFilter: true,
  };

  const tableHeadCellProps = {
    align: "left",
    sx: {
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  console.log(clientes);
  
  return (
    <div>
      <Navbar />
      {tabla && (
      <Container maxWidth="xl" disableGutters sx={{ mb: 2, mt: 2.5 }}>
        <MaterialReactTable
          columns={columns}
          data={clientes ?? [{}]}
          layoutMode={"grid"}
          initialState={initialState}
          enableColumnActions={false}
          enableGlobalFilterModes={true}
          enableHiding={false}
          enableRowActions={true}
          enableGrouping={true}
          enablePinning={true}
          enableColumnFilters={false}
          enableFullScreenToggle={false}
          positionActionsColumn={"last"}
          enableExpandAll={false}
          localization={customLocalization}
          enableToolbarInternalActions={true}
          muiTableHeadCellProps={tableHeadCellProps}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          enableDensityToggle={false}
          muiTableBodyRowProps={({ row }) => ({
            sx: {
              cursor: "pointer",
            },
          })}
          enableColumnResizing={true}
          muiTableBodyCellProps={({ row }) => ({
            align: "left",
            sx: {
              color: "black",
            },
          })}
          muiTableDetailPanelProps={{
            sx: {
              backgroundColor: "white",
              width: "100%",
            },
          }}
            renderTopToolbarCustomActions={() => (
              <>
                <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                  <ReceiptIcon sx={{ fontSize: 20 }} />
                  <Typography variant="h6" component="div">
                    Entrega Con Remito 
                  </Typography>
                </Box>
              </>
            )}
            renderRowActionMenuItems={({ closeMenu, row }) => [
              <MenuItem
                key={`clientes-${row.original.id}`}
                onClick={() => {
                  navigate("/envasadoclientesasociados", { state: row.original });
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <PeopleIcon color="success" />
                </ListItemIcon>
                Clientes Asociados
              </MenuItem>,
              <MenuItem
                key={`resumen-entregas-${row.original.id}`}
                // onClick={() => {
                  
                //   // navigate("/envasadoresumenentregas", { state: row.original });
                //   closeMenu();
                // }}
                onClick={() => {
                      setClienteAFacturar(row.original);
                      setShowNuevaFactura(true);
                      setTabla(false);
                      closeMenu();
                    }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <ReceiptLongIcon color="error" />
                </ListItemIcon>
               A Facturar
              </MenuItem>,
              <MenuItem
                key={`resumen-entregas-${row.original.id}`}
                onClick={() => {
                  navigate("/envasadoremitosfacturados", { state: row.original });
                  closeMenu();
                }}
                sx={{ m: 0 }}
              >
                <ListItemIcon>
                  <ReceiptIcon color="primary" />
                </ListItemIcon>
               Facturados
              </MenuItem>,
            ]}
        />
      </Container>
      )}
      {showNuevaFactura && clienteAFacturar && (
        <NuevaFacturacion
          origen="envasado"
          dataCliente={clienteAFacturar}
          close={closeNuevaFacturacion}
        />
      )}
    </div>
  );
}

export default EntregaConRemito;
